import './task1';
import './task2';
import './task3';